"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _HBMediaElement = _interopRequireDefault(require("../HBMediaElement/HBMediaElement"));
var PreloadMediaElements = function PreloadMediaElements(_ref) {
  var mediaPaths = _ref.mediaPaths;
  return /*#__PURE__*/(0, _reactDom.createPortal)(/*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'none'
    }
  }, mediaPaths.map(function (mediaPath) {
    return /*#__PURE__*/_react["default"].createElement(_HBMediaElement["default"], {
      key: mediaPath,
      path: mediaPath
    });
  })), document.head);
};
var _default = exports["default"] = PreloadMediaElements;
//# sourceMappingURL=PreloadMediaElements.js.map